import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { webRoutes } from '../../routes/web';

const Redirect = () => {
  const admin = useSelector((state) => state.admin);
  const { locations } = useSelector((state) => state.location);

  if (admin && !admin.user?.isAdmin && !locations?.[0]?.isReviewUser && locations?.[0]?.isAuthorized) {
    return <Navigate to={webRoutes.authorizations} replace />;
  }

  return <Navigate to={admin ? webRoutes.dashboard : webRoutes.login} replace />;
};

export default Redirect;
